import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

export const fetchUploadList = createAxiosThunk(
  'bulk/fetchUploadList',
  (noArgs, { getState }) => {
    const { page, size } = getState().bulk.upload
    return api.bulk.getUpload(page, size)
  }
)

export const cancelUpload = createAxiosThunk('bulk/cancelUpload', massiveId =>
  api.bulk.cancelUpload(massiveId)
)

export const fetchUploadFile = createAxiosThunk(
  'bulk/fetchUploadFile',
  massiveId => api.bulk.getUploadFile(massiveId)
)

const initialState = {
  isLoading: false,
  content: [],
  totalElements: 0,
  page: 0,
  size: 20,
  disabledCancel: false,
  disabledDownload: false,
}

const uploadSlice = createSlice({
  name: 'bulk/upload',
  initialState,

  reducers: {
    setPage: (state, { payload: page }) => {
      state.page = page
    },
    reset: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchUploadList.pending, state => {
      state.isLoading = true
    })

    builder.addCase(fetchUploadList.rejected, state => {
      state.content = []
      state.totalElements = 0
      state.isLoading = false
    })

    builder.addCase(
      fetchUploadList.fulfilled,
      (state, { payload: { data } }) => {
        state.content = data.content
        state.totalElements = data.totalElements
        state.isLoading = false
      }
    )

    builder.addCase(cancelUpload.pending, state => {
      state.disabledCancel = true
    })

    builder.addCase(cancelUpload.rejected, state => {
      state.disabledCancel = false
    })

    builder.addCase(cancelUpload.fulfilled, state => {
      state.disabledCancel = false
    })

    builder.addCase(fetchUploadFile.pending, state => {
      state.disabledDownload = true
    })

    builder.addCase(fetchUploadFile.rejected, state => {
      state.disabledDownload = false
    })

    builder.addCase(fetchUploadFile.fulfilled, state => {
      state.disabledDownload = false
    })
  },
})

const { actions, reducer } = uploadSlice
export const { setPage, reset } = actions
export default reducer
